class Faq {
    init() {
        this.initFaq();
    }

    initFaq() {
        let faqTitle = document.querySelectorAll('.faq-item-title');

        faqTitle.forEach(title => {
            title.addEventListener('click', (event) => {
                event.target.parentNode.classList.toggle('faq-item--active');
            });
        });
    }
}

export default Faq;

(() => {
    const faq = new Faq();
    faq.init();
})();